import { useQuery } from '@tanstack/react-query';
import { getPublicAudios } from '../../services';
import { AudioModelType } from 'apps/t2c-fe/utils';

export const useGetPublicAudios = (model?: AudioModelType) => {
  return useQuery(['publicAudios', model ?? 'all'], () => getPublicAudios(model));
};
